module.exports = __webpack_public_path__ + "img/link-xy.bdb9b76c.png";